module.exports = __webpack_public_path__ + "img/daten-icon-gray.e3ad0e37.svg";